module.exports = __webpack_public_path__ + "static/img/man.106b528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/man.png
// module id = JBOh
// module chunks = 410